import { render, staticRenderFns } from "./ConfirmToken.vue?vue&type=template&id=650fa6f4&scoped=true&"
import script from "./ConfirmToken.vue?vue&type=script&lang=js&"
export * from "./ConfirmToken.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmToken.vue?vue&type=style&index=0&id=650fa6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650fa6f4",
  null
  
)

export default component.exports